module.exports = __webpack_public_path__ + "img/pic_ogrod.054861db.svg";